import React, { useState } from 'react';
import { useIsMobile } from '@repo/common';
import BillingHeader from './BillingHeader';
import BillingLogHeader from './BillingLogHeader';
import BillingLog from './BillingLog';
import BillingRow from './BillingRow';
import { ReactComponent as MobileChevronUpIcon } from '@repo/common/assets/icons/16px/icon_16px_arrow-top.svg';

const BillingHistory = ({ data, invoiceData }) => {
  const isMobile = useIsMobile();
  const [open, setOpen] = useState(false);

  const events = data ?? [];
  const count = events.length;

  if (isMobile) {
    return (
      <div className='rounded-[15px] bg-grayscale-gray00 p-4 border border-grayscale-gray02 w-full'>
        <button
          onClick={() => setOpen((v) => !v)}
          className='flex items-center justify-between w-full pb-3 border-b border-grayscale-gray01'
        >
          <span className='typo-b16Strong text-text-primary'>
            Billing history ({count})
          </span>
          <div className='size-[26px] flex items-center justify-center'>
            <MobileChevronUpIcon
              className={`text-icon-placeholder transition-transform ${open ? '' : 'rotate-180'}`}
            />
          </div>
        </button>

        {open ? (
          <BillingLog data={events} invoiceData={invoiceData} $isMobile />
        ) : (
          <div className='flex flex-col gap-3 pt-3'>
            {events[0] && (
              <BillingRow
                data={events[0]}
                invoiceData={invoiceData}
                $isMobile
                hideConnector
              />
            )}
            {count > 1 && (
              <button
                onClick={() => setOpen(true)}
                className='typo-b12Strong text-green-deep03 text-left'
              >
                Tap to view all {count} events
              </button>
            )}
          </div>
        )}
      </div>
    );
  }

  return (
    <div className='flex flex-col items-start p-[30px] gap-6 rounded-[20px] bg-grayscale-gray00 w-full'>
      <BillingHeader />
      <div className='w-full'>
        <BillingLogHeader />
        <BillingLog data={data} invoiceData={invoiceData} />
      </div>
    </div>
  );
};

export default BillingHistory;
